export default __webpack_public_path__ + "static/media/icons8-transverse-wave-graph-uncertainty-performance-statistics-report-96.82d806b0.svg";